const IMAGE_EXTENSIONS = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "webp",
  "svg",
  "ico",
  "tiff",
  "tif",
];

export const getFileExtension = (name: string): string => {
  const dot = name.lastIndexOf(".");
  return dot >= 0 ? name.slice(dot + 1).toLowerCase() : "";
};

export const isImageFile = (file: File): boolean =>
  file.type.startsWith("image/") ||
  IMAGE_EXTENSIONS.includes(getFileExtension(file.name));

export const generateUniqueFilename = (file: File, index = 0): string => {
  const ext = getFileExtension(file.name);
  return `${Date.now()}_${index}${ext ? `.${ext}` : ""}`;
};

export const renameFile = (file: File, newName: string): File =>
  new File([file], newName, { type: file.type });
